import getRemoteUrl from "../get-remote-url";

// import type Affiliate from "pacsbin-core/src/db/old-models/Affiliate";
import { OrgConfig } from "../import/dicomweb/types";
import ky from "ky";
// import * as dicomwebClient from '../import/dicomweb/dicomweb-client';

// MRI Lumbar spine: 1762021853709597 (1 series)


/**
 * If this specific org is requested, just load this mock data for testing purposes.
 */
const testOrgId = "5e28930dd9aa69b583ea4deb";
const testOrgConfig = {
  _id: "5e28930dd9aa69b583ea4deb",
  administrators: ["51b7d26e2c107cb12b000001"],
  allowAnyUser: false,
  members: [
    "jhostetter.md@gmail.com",
    "qwerty@uiop.com",
    "jasontesting@pacsbin.com",
    "jhostetter@gmail.com",
  ],
  visibility: "private",
  apiKeys: [
    {
      maxAge: 3600000,
      _id: "5e28930dd9aa69b583ea4dec",
      name: "Default Key",
      key: "093d5e1d-57b1-4b50-a03a-999f5973f601",
    },
  ],
  name: "TEST",
  location: "TEST LOC",
  createdAt: new Date("1579717389539"),
  updatedAt: new Date("1642707460749"),
  nameUpper: "TEST",
  __v: 0,
  dicomweb: {
    endpoints: [
      {
        name: "test1",
        description: "Orthanc dicomweb server",
        qidoBaseUrl: "http://localhost:8043/dicom-web",
        wadoBaseUrl: "http://localhost:8043/dicom-web",
        params: {
          first: "one",
          second: "two with& special () chars",
        },
      },
    ],
    defaultEndpoint: "test1",
  },
};

export default async function getOrganizationConfigs(): Promise<OrgConfig | null> {
  const searchParams = new URLSearchParams(window.location.search);
  const orgId = searchParams.get("org");
  const urlEndpoint = searchParams.get("endpoint");

  if (!orgId) {
    return null;
  }

  let organization: {
    _id: string;
    name: string;
    dicomweb: {
      endpoints: {
        name: string;
        description: string;
        qidoBaseUrl: string;
        wadoBaseUrl: string;
        params: {
          first: string;
          second: string;
        };
      }[];
      defaultEndpoint: string;
    };
  };

  if (orgId === testOrgId) {
    organization = testOrgConfig;
  } else {
    const organizationUrl = getRemoteUrl(`/api/organization/${orgId}`);
    organization = await ky
      .get(organizationUrl, { credentials: "include" })
      .json();
  }

  console.log("Loaded org:", organization);

  let defaultEndpoint = organization.dicomweb.endpoints.find(
    (endpoint) => endpoint.name === urlEndpoint
  );
  if (!defaultEndpoint) {
    console.warn(
      `Endpoint named ${urlEndpoint} specified in the URL not found in the configuration. Using config default.`
    );
    defaultEndpoint = organization.dicomweb.endpoints.find(
      (endpoint) => endpoint.name === organization.dicomweb.defaultEndpoint
    );
  }

  const endpoint = defaultEndpoint || organization.dicomweb.endpoints[0];

  if (!endpoint.wadoBaseUrl || !endpoint.qidoBaseUrl) {
    throw new Error("Must define both WADO and QIDO base urls");
  }

  // dicomwebClient.init(endpoint.wadoBaseUrl, endpoint.qidoBaseUrl);

  return {
    orgName: organization.name,
    orgId: organization._id.toString(),
    config: organization.dicomweb,
    endpoint,
  };
}
